const id_master_goodsPriceTier = {
    "": "Tingkat Harga",
    title: "Tingkat Harga [ {{ item }} ]",

    error: {
        edit: 'Gagal mengubah tingkat harga',
    },

    success: {
        edit: 'Berhasil mengubah tingkat harga',
    },
}

export default id_master_goodsPriceTier;